import { CurrentHealthcareProviderConfiguration } from '@dreryk/egabinet-patient-portal-frontend-api';
import { EmailAddress } from '@dreryk/email-address-common-api';

import { appointmentRequestsConfigurationToFormBean } from '../healthcareProviderPatientPortalSettings/AppointmentRequestsSettingsForm/AppointmentRequestsSettingsForm.utils';
import { preInterviewConfigurationToFormBean } from '../preInterviewSettings/form/PreInterviewSettingsForm.utils';

import { HealthcareProviderConfigurationFormBean } from './HealthcareProviderConfigurationForm.types';

export const formInitializer = (
   configuration: CurrentHealthcareProviderConfiguration | null,
   defaultAppointmentRequestsEmail: EmailAddress | null
): HealthcareProviderConfigurationFormBean => {
   return {
      ...preInterviewConfigurationToFormBean(configuration?.preInterviewConfiguration),
      ...appointmentRequestsConfigurationToFormBean(configuration, defaultAppointmentRequestsEmail),
   };
};
